<div class="container">
  <div class="row">
      <div class="col-md-6 offset-md-3">
          <h3>Choose File</h3>
          <div class="form-group">
              <input type="file" name="image" (change)="fileProgress($event)" />
          </div>
          <div *ngIf="fileUploadProgress">
              Upload progress: {{ fileUploadProgress }}
          </div>
          <div class="image-preview mb-3" *ngIf="previewUrl">
              <img [src]="previewUrl" width="100" />
          </div>

          <div class="mb-3" *ngIf="uploadedFilePath">
              {{uploadedFilePath}}
          </div>

          <div class="form-group">
              <button class="btn border"  (click)="onSubmit()">Submit</button>
          </div>
      </div>
  </div>
</div>

<div class="col-md-4">
<quill-editor [(ngModel)]="editorContent" [styles]="{height: '500px'}" [sanitize]=true>

    <div quill-editor-toolbar>
        <span class="ql-formats">
            <select class="ql-font" title="Font">
              <option selected></option>
              <option value="serif"></option>
              <option value="monospace"></option>
            </select>
            <select class="ql-size" title="Textstorlek">
              <option value="small"></option>
              <option selected></option>
              <option value="large"></option>
              <option value="huge"></option>
            </select>
          </span>
          <span class="ql-formats">
            <button class="ql-bold"></button>
            <button class="ql-italic"></button>
            <button class="ql-underline"></button>
            <button class="ql-strike"></button>
          </span>
          <span class="ql-formats">
            <select class="ql-color" title="Textfärg"></select>
            <select class="ql-background" title="Bakgrundsfärg"></select>
          </span>
          <span class="ql-formats">
            <button class="ql-list" value="ordered"></button>
            <button class="ql-list" value="bullet"></button>
            <select class="ql-align">
              <option selected></option>
              <option value="center"></option>
              <option value="right"></option>
              <option value="justify"></option>
            </select>
          </span>
          <span class="ql-formats">
            <button class="ql-link"></button>
            <button class="ql-image"></button>
          </span>
      </div>


</quill-editor>
</div>

<div class="one" [innerHtml]="editorContent"></div>
{{editorContent}}
